import { createContext, useContext } from 'react';
import type { PriceCadence } from '@/types/database';

export type SubscriptionStatus = 'active' | 'expired' | 'cancelled' | 'none';

export interface SubscriptionState {
  isPremium: boolean;
  status: SubscriptionStatus;
  isLoading: boolean;
  cadence: PriceCadence | null;
  priceId: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  cancelAt: string | null;
}

export interface SubscriptionContextType extends SubscriptionState {
  refreshSubscription: () => Promise<void>;
  checkFeatureAccess: (feature: 'practice' | 'interview') => {
    hasAccess: boolean;
    reason?: string;
  };
}

export const SubscriptionContext = createContext<
  SubscriptionContextType | undefined
>(undefined);

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error(
      'useSubscription must be used within a SubscriptionProvider'
    );
  }
  return context;
}
